import Swiper from "swiper";
import SwiperCore, {
    Navigation,
    Autoplay,
    Pagination,
    Lazy,
} from "swiper/core";

SwiperCore.use([Navigation, Autoplay, Pagination, Lazy]);
import {getElement, removeActive} from "../modules/helpers.js";
import {
    findVariationInProducts,
    renderColors,
    renderAttributes,
    getVariationFromAttributes,
    renderActiveAttributes,
    renderSwiperImages, objectAttributesCreate, findVariationInFilteredProducts
} from "../productPage/productItem.js";
import {renderRatingHTML, findPersonalColor, findAttributeSlug} from "../productPage/renderProductInfo.js";
import {isCummerbund} from "../catalogPage/filterEvents.js";


export default function catalogItem(elements, filteredAttributes = null) {
    document.querySelectorAll("[data-catalog-item]").forEach((item) => {
        if (!item.dataset.catalogItem || !elements) return;
        const productCat = elements.find(el => el.productId == item.dataset.catalogItem);
        const {
            rating: {rating},
            attributes: {defaultAttributes, allAttributes},
            variations,
            currency,
            link,
            productId, plate, modal_size
        } = productCat
        item.dataset.productId = productId;

        renderRatingHTML(item, rating);
        item.querySelector('.stars').insertAdjacentHTML('beforeend', `<span class=" ml-5">${rating}</span>`);
        item.querySelector('[data-select="pa_color"]').innerHTML = `
            ${renderColors(productCat) ? renderColors(productCat) : '<div data-pa_color="" data-select-item class="active">No available colors </div>'}
        `
        if (plate) {
            item.querySelector('[data-select="pa_color"]').classList.add('none')
        }
        item.querySelector('[data-attributes="configurations"]').innerHTML = `${renderAttributes(productCat)}`

        let defaultItem, attributesForRender = {};
        attributesForRender.attributes = JSON.parse(JSON.stringify(defaultAttributes));

        if (!defaultItem) defaultItem = variations[0];
        if (productCat.defaultItem) defaultItem = productCat.defaultItem
        if (isLogin && personalInfo && !productCat.defaultItem) {


            if (personalInfo.pa_color && findPersonalColor(personalInfo.pa_color, allAttributes)) attributesForRender.attributes.pa_color = personalInfo.pa_color;

            if (personalInfo.personalized[modal_size]) {
                if (modal_size == 'bodySize') {
                    let {bodySizeVest, bodySizeCummerband} = personalInfo.personalized;
                    if (bodySizeVest && findAttributeSlug(bodySizeVest, allAttributes)) {
                        attributesForRender.attributes.pa_size = findAttributeSlug(bodySizeVest, allAttributes)
                    }
                    if (bodySizeCummerband && findAttributeSlug(bodySizeCummerband, allAttributes, "pa_cummerbund-size")) {
                        attributesForRender.attributes['pa_cummerbund-size'] = findAttributeSlug(bodySizeCummerband, allAttributes, "pa_cummerbund-size")
                    }

                } else {
                    if (findAttributeSlug(personalInfo.personalized[modal_size], allAttributes)) attributesForRender.attributes.pa_size = findAttributeSlug(personalInfo.personalized[modal_size], allAttributes)
                }
            }
            defaultItem = findVariationInProducts(attributesForRender.attributes, productCat) ? findVariationInProducts(attributesForRender.attributes, productCat) : variations[0];
            // defaultItem = attributesForRender.attributes;
            // console.log(attributesForRender)
        }
        let {price, regular_price} = defaultItem;
        renderStockStatus(item, defaultItem);
        let discount = Math.round((1 - +price / +regular_price) * 100);
        if (discount && discount != 0 && item.querySelector('[data-product-discount]')) {
            item.querySelector('[data-product-discount]').innerText = `${discount}%`
        }
        item.querySelectorAll('[data-attributes]').forEach(
            attributes => {
                renderActiveAttributes(attributes.querySelectorAll('[data-select]'), defaultItem, productCat);
                item.querySelectorAll('[data-href]').forEach(a => {
                    if (formLinkAttr(item)) {
                        a.href = `${link}?${formLinkAttr(item)}`;

                        item.dataset.variationHref = `${link}?${formLinkAttr(item)}`;
                    } else {
                        a.href = `${link}`;

                        item.dataset.variationHref = `${link}`;
                    }
                })

                item.querySelector('.price').innerHTML = `
             <div data-price-new="${price}" class=" h2 fw-600 mr-10">${currency}${Math.round(+price)}</div>
                <s data-price-old="${regular_price}">${regular_price !== '' && price != regular_price ? currency + Math.round(+regular_price) : ''}</s>
        `;

                attributes.querySelectorAll('[data-select]').forEach(select => {
                    select.querySelectorAll('[data-select-item]').forEach(selectItem => {
                        selectItem.addEventListener('click', () => {
                            removeActive(select.querySelectorAll('[data-select-item]'));
                            selectItem.classList.add("active");
                            if (selectItem.dataset.pa_size) {
                                if (attributes.querySelector('[data-select=pa_cummerbund-size]')) {
                                    removeActive(getElement('[data-select=pa_cummerbund-size]').querySelectorAll('[data-select-item]'));
                                    attributes.querySelector('[data-select=pa_cummerbund-size]').querySelectorAll('[data-select-item]').forEach(cummerbundSizeItem => {
                                        if (selectItem.dataset.pa_size == cummerbundSizeItem.dataset.pa_cummerbundSize) {
                                            cummerbundSizeItem.classList.add("active")
                                        }

                                    })
                                }
                            }

                            getVariationFromAttributes(item, productCat);
                            renderActiveAttributes(item.querySelectorAll('[data-select]'), objectAttributesCreate(item), productCat);

                            let href = `${link}?${formLinkAttr(item)}`
                            item.querySelectorAll('[data-href]').forEach(a => {
                                a.href = href;
                                item.dataset.variationHref = href;
                            })


                        })
                    })
                })

            })
        const gallery = item.querySelector('.catalog-item__gallery').querySelector('.swiper-wrapper');
        item.querySelector('[data-select="pa_color"]').querySelectorAll('[data-select-item]').forEach(colorBtn => {

            if (colorBtn.classList.contains('active')) {
                gallery.innerHTML = renderSwiperImages(productCat, colorBtn.dataset.pa_color);
                gallery.querySelectorAll('[data-href]').forEach(a => {
                    a.href = item.dataset.variationHref;
                })
                catalogItemSlider(gallery.parentNode.dataset.swiper);


            }
            colorBtn.addEventListener('click', () => {
                gallery.innerHTML = renderSwiperImages(productCat, colorBtn.dataset.pa_color);
                catalogItemSlider(gallery.parentNode.dataset.swiper);
                gallery.querySelectorAll('[data-href]').forEach(a => {
                    a.href = item.dataset.variationHref;
                })
            })
        });
        if (plate) {
            let linkStr = ''
            item.querySelector('[data-select="pa_size"]').querySelectorAll('[data-pa_size]').forEach(activeAttr => {

                if (activeAttr.classList.contains('active')) {

                    linkStr = activeAttr.dataset.pa_size;
                }
            })
            const div = document.createElement('div')
            plate.forEach(plateItem => {
                const {name, links} = plateItem;

                if (name == 'type') {
                    const btns = function () {
                        let fragment = ``;
                        links.forEach((link) => {
                            const {attrName, href, id} = link

                            if (id == productId) {
                                return fragment += `
                  <button class="switcher__item border-black active h3 fw-500" data-plate-id="${id}">  <span>${attrName}</span></button>
                `
                            }
                            return fragment += `
                  <a href="${href}?attribute_pa_size=${linkStr}" class="switcher__item txt-no-underline h3 fw-500">  <span>${attrName}</span></a>
                `
                        })
                        return fragment
                    }
                    div.classList = `switcher flex br--6 `;
                    if (links.length == 1) {
                        div.classList.add('switcher_one')
                    }
                    div.dataset.plate = true;
                    div.innerHTML = btns();
                    return div;
                }
                return div;
            })
            if (item.querySelector('[data-plate]')) return;
            item.querySelector('[data-select="pa_color"]').insertAdjacentElement('beforebegin', div)
        }
    });
}

function formLinkAttr(item) {
    let objectAttributes = objectAttributesCreate(item);
    let str = '';
    for (let key in objectAttributes) {
        str += `attribute_${key}=${objectAttributes[key]}&`
    }
    return str.slice(0, -1);
}


function catalogItemSlider(id) {


    const swiperProductItem = new Swiper(
        document.querySelector(`[data-swiper="${id}"]`),
        {
            slidesPerView: 1,
            // spaceBetween: 10,
            loop: true,
            slideClass: "catalog-item__image",
            preloadImages: false,
            lazy: true,
            pagination: {
                el: `.swiper-pagination`,
                clickable: true,
            },
            navigation: {
                nextEl: `.slider__next-catalog-item-id-${id}`,
                prevEl: `.slider__prev-catalog-item-id-${id}`,
            },
            grabCursor: true,

        }
    );
    return swiperProductItem


}

function renderStockStatus(parent, obj) {
    const stock = parent.querySelector('[data-product-stock]');
    if (!stock) return
    const {in_stock, stock_status} = obj;
    let inStock = in_stock ? true : false;
    let clazz = 'label  mr-15'
    let descr = '';
    if (inStock) {
        clazz += ' label--green';
        descr = ` <svg class="icon mr-5"><use xlink:href="#check"></use></svg><span>${stock_status}</span>`;
        stock.dataset.productStock = true;
    } else {
        clazz += in_stock ? ' label--green' : ' label--gray';
        // descr = `<span>${stock_status}</span>`;
        descr = stock_status;
        stock.dataset.productStock = false;
    }
    if (stock) {
        stock.innerHTML = descr;
        stock.classList = clazz;
    }


}

export {catalogItemSlider, formLinkAttr, renderStockStatus};

